import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { withWidth, makeStyles, Typography } from "@material-ui/core";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(
  (theme) => ({
    root: {},
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    link: {
      fontStyle: "italic",
      textDecoration: "underline",
      cursor: "pointer",
      textAlign: "center",
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.75rem",
      },
    },
    dialogButton: {
      lineHeight: 1,
      margin: "16px 0",
    },
    textArea: {
      borderColor: theme.palette.primary.light,
    },
    iconButton : {
        minWidth: 34,
        width: 34,
        height: 34,
        padding: 0,
        right: 10,
        borderRadius: 17,
        fontSize: "1.5rem",
        fontWeight: "lighter"
    }
  }),
  { name: "AddToCartComment" }
);

const AddToCartComment = ({ width, setConfigurationComment, userComment }) => {
  const classes = useStyles({});
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState("");
  useEffect(() => {
    setComment(userComment);
  }, [userComment, open]);
  const handleClose = () => setOpen(false);
  const handleChange = useCallback(
    ({ target: { value } }) => {
      setComment(value);
    },
    [setComment]
  );
  const handleOkClick = () => {
    setConfigurationComment(comment);
    setOpen(false);
  };
  return (
    <div className={classes.container}>
      <Button
        variant="contained"
        color="primary"
        className={classes.iconButton}
        onClick={() => setOpen(true)}
      >
        +
      </Button>
      <Typography
        className={classes.link}
        variant="body1"
        onClick={() => setOpen(true)}
      >
        {t("addToCartComment.openButtonLabel")}
      </Typography>
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth={"md"}
        fullWidth
        fullScreen={width === "sm" || width === "xs"}
        scroll="paper"
        disableBackdropClick
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            {t("addToCartComment.dialogTitle")}
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <TextField
            label={t("addToCartComment.commentInputLabel")}
            multiline
            minRows="3"
            maxRows="3"
            value={comment}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
            fullWidth
            InputProps={{ classes: { notchedOutline: classes.textArea } }}
            className={classes.textArea}
          />
          <Grid container direction="row" justify="flex-end">
            <Button
              className={classes.dialogButton}
              variant="contained"
              color="primary"
              onClick={handleOkClick}
            >
              {t("addToCartComment.okButtonLabel")}
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

AddToCartComment.propTypes = {
  width: PropTypes.string.isRequired,
  setConfigurationComment: PropTypes.func.isRequired,
  userComment: PropTypes.string.isRequired,
};

export default withWidth()(AddToCartComment);
